<template>
    <div>
        <b-button-group size="sm" class="w-100">
            <b-button
                variant="table"
                v-if="checkActionAllow('edit')"
                @click="createOrEditItemModal(row.index)"
            >
                <i class="fas fa-pencil-alt"></i>
            </b-button>
            <b-button
                variant="table"
                v-if="checkActionAllow('delete')"
                @click="deleteItem(row.index)"
            >
                <i class="fas fa-trash text-danger"></i>
            </b-button>
        </b-button-group>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import {
        checkActionAllow
    } from '@/mixins'

    export default {
        props: {
            row: {type: Object, required: true},                                                // Row of table
            actionAllows: {type: Array, required: false, default: function () { return [] }},   // Array of rules for action allows
        },
        mixins: [
            checkActionAllow
        ],
        computed: {
            ...mapGetters('auth', ['currentUser'])
        },
        methods: {
            createOrEditItemModal(index) {
                this.$emit('universalEmit', 'edit', index)
            },
            deleteItem(index) {
                this.$emit('universalEmit', 'delete', index)
            }
        }
    }
</script>

